module.exports = __webpack_public_path__ + "static/media/tutorial.1328f056.webp";